import { AppHelper } from "../appHelper";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { FieldInstance } from "../core/components/field";
import { DropDownList } from "../core/components/dropDownList";
import { Grid } from "../core/components/grid";
import { General } from "../../siteManagement/general";
import { Sheet } from "../../siteManagement/sheet";
import { DateTimePicker } from "../core/components/dateTimePicker";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { FAIcon } from "../core/components/faIcon";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import React from "react";
import ReactDOM from "react-dom";

export default class ServerLog extends React.Component<any, ServerLogState> {
    common = new AppHelper();
    private _factory = ComponentHelper.createFactory();
    private _translations = {};
    private _gridData = [];
    private _gridOptions = {};
    private _filterDataUrl: string;
    private _sheet: Sheet = null;
    private _startDateRef: kendo.ui.DateTimePicker = null;
    private _endDateRef: kendo.ui.DateTimePicker = null;


    constructor(props) {
        super(props);
        this._translations = this.props.translations;
        this._filterDataUrl = "ServerProtokoll/FilterGridData";
        let metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name == "serverLogGridOptions");
        this._gridOptions = metaDataAdditional[0].data;
        this.state = {
            Typid: 0,
            Beschreibung: "",
            Datumvon: new Date(new Date().setHours(0, 0, 0, 0)) ,
            Datumbis: new Date(new Date().setHours(23, 59, 59, 59)),
            Jobid: null
        
        };

        this.common.init(this);
        this._gridData = this.props.entity.ProtokollListe;
        
        this._sheet = General.Sheet.Manager.getTopMostSheet();
    }
    private _setStartDateRef = (ref: DateTimePicker) => {
        this._startDateRef = ref ? ref.getDateTimePickerRef() : null;
        if (this._startDateRef) {
            this._startDateRef.max(this.state.Datumbis);
        }
    }

    private _setEndDateRef = (ref: DateTimePicker) => {
        this._endDateRef = ref ? ref.getDateTimePickerRef() : null;
        if (this._endDateRef) {
            this._endDateRef.min(this.state.Datumvon);
        }
    }
    private _filterGridData =()=>{
        const qsp = {
            proTyp: (Helper.hasValue(this.state.Typid) ? this.state.Typid : 0),
            text: (Helper.hasValue(this.state.Beschreibung) ? this.state.Beschreibung : ""),
            von: (Helper.hasValue(this.state.Datumvon) ? this.state.Datumvon : ""),
            bis: (Helper.hasValue(this.state.Datumbis) ? this.state.Datumbis : ""),
            jobid: (Helper.hasValue(this.state.Jobid) ? this.state.Jobid : null)
        };
        const url = this._filterDataUrl + Helper.addQueryStringParameters("", qsp);
        HTTPService.post<JsonResultClass>(url)
            .then(result => {
                this._gridData = result.Data;    
                this.setState({
                    ...this.state
                });
            }
            );
    }
    private _onTextBoxChange = (field, value) => {
        if (field.model === "Suche") {
            if (value == "<" || value === ">" || value === "#") {
                value = "";
            }
            this.setState({ ...this.state, Beschreibung: value });
        } if (field.model === "Jobid") {
            this.setState({ ...this.state, Jobid: value });
        }
    }

    private _onChangeDropDownList = (field, value) => {
        if (field.model === "Typeid") {
            if (Helper.hasValue) {
                this.setState({ ...this.state, Typid: value });                   
            }
        }
    }
    private _onDatePickerChange = (field, value) => {
        if (field.model === "DatumVon") {
            this._endDateRef.min(value);
            this.setState({ ...this.state, Datumvon: value });
                
        } else if (field.model === "DatumBis") {
            this._startDateRef.max(value);
            this.setState({ ...this.state, Datumbis: value });
        }

    }
    componentDidMount = () => {
        if (this.props.entity.ProtokollListe.length > 0) {
            this.setState({ ...this.state, Jobid: this.props.entity.ProtokollListe[0].Jobid });
        }
    }
    private _gettextBoxSucheProps = () => {
        const props = this._factory.getDefaultTextBoxProps();
        props.field.readOnly = false;
        props.value = this.state.Beschreibung;
        props.onChange = this._onTextBoxChange;
        props.field.triggerOnChange = true;
        props.field.model = "Suche";
        return props;
    }
    private _gettextBoxJobidProps = () => {
        const props = this._factory.getDefaultNumericTextBoxProps();
        props.field.readOnly = false;
        props.value = this.state.Jobid;
        props.onChange = this._onTextBoxChange;
        props.value = this.state.Jobid;
        props.field.model = "Jobid";
        return props;
    }
    private _getFilterDropDownListProps = () => {
        const props = this._factory.getDefaultDropDownProps();
        props.value = this.state.Typid;
        props.field.model = "Typeid";
        props.onChange = this._onChangeDropDownList;
        props.field.dataSourceUrl = "ServerProtokoll/GetProtokollTyp"
        props.field.dataValueField = "Typeid";
        props.field.dataTextField = "Description";
        return props;
    }
    private _getDateickerVonProps = () => {
        const props = this._factory.getDefaultDateTimePickerProps();
        props.field.readOnly = false;
        props.value = this.state.Datumvon;
        props.onChange = this._onDatePickerChange;
        props.field.model = "DatumVon";
        return props;
    }
    private _getDateickerBisProps = () => {
        const props = this._factory.getDefaultDateTimePickerProps();
        props.field.readOnly = false;
        props.value = this.state.Datumbis;
        props.onChange = this._onDatePickerChange;
        props.field.model = "DatumBis";
        return props;
    }
    private renderFilter = () => {
        return ReactDOM.createPortal(
            <>
                <style>
                    {
                        `
                            div.drawer--left:not(.drawer--closed) .serverLogFilter{
                                display: flex;
                                flex-direction: column;
                            }

                            div.drawer--left.drawer--closed .serverLogFilter{
                                display: none;
                            }
                        `
                    }
                </style>
                <div className="serverLogFilter">
                    <FullHeightContainer >
                        <button onClick={() => { this._filterGridData() }} className="k-button" style={{ backgroundColor: "var( --primary-color)", color: "white", border: "none", padding: "8px", margin: "5px", borderRadius: "var(--border-radius)" }}>
                            <FAIcon name="search" style={{ marginRight: "5px" }} />
                            {this._translations["WebSMS.DataExchangeModule.Protocol.Filter"]}
                        </button>
                        <div style={{ display: 'flex', margin: '10px', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '3px' }}> {this._translations["WebSMS.DataExchangeModule.Protocol.Filter"]} </label>
                            <DropDownList{...this._getFilterDropDownListProps()} />
                        </div>
                        <div style={{ display: 'flex', margin: '10px', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '3px' }}> {this._translations["WebSMS.DataExchangeModule.Jobid"]} </label>
                            <IsNumericTextBox {...this._gettextBoxJobidProps()} />
                        </div>
                        <div style={{ display: 'flex', margin: '10px', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '3px' }}> {this._translations["WebSMS.DataExchangeModule.Protocol.Search"]} </label>
                            <TextBox {...this._gettextBoxSucheProps()} />
                        </div>
                        <div style={{ display: 'flex', margin: '10px', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '3px' }}> {this._translations["WebSMS.DataExchangeModule.Von"]} </label>
                            <DateTimePicker {...this._getDateickerVonProps()} ref={this._setStartDateRef} />
                        </div>
                        <div style={{ display: 'flex', margin: '10px', flexDirection: 'column' }}>
                            <label style={{ marginBottom: '3px' }}> {this._translations["WebSMS.DataExchangeModule.Bis"]}</label>
                            <DateTimePicker {...this._getDateickerBisProps()} ref={this._setEndDateRef} />
                        </div>

                    </FullHeightContainer>

                </div>
            
            </>, this._sheet.elements.getLeftDrawerElementRef()[0]
        )
    }

    render() {
        const content = <Grid data={this._gridData} options={this._gridOptions} id="projectWarenpos" />
        return (<>
            <div className="region-container">
                {content}
            </div>
            {this.renderFilter()}
        </>);

    }

};
interface ServerLogState {
    Typid: number,
    Beschreibung: string,
    Datumvon: Date,
    Datumbis: Date,
    Jobid: number
}
